import { render, staticRenderFns } from "./academic_set_examination.vue?vue&type=template&id=5c805fd5&scoped=true&"
import script from "./academic_set_examination.vue?vue&type=script&lang=js&"
export * from "./academic_set_examination.vue?vue&type=script&lang=js&"
import style0 from "./academic_set_examination.vue?vue&type=style&index=0&id=5c805fd5&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c805fd5",
  null
  
)

export default component.exports